import axios from 'axios';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    }
    return 'https://repair-Pybackend.smartgonext.com';
  }
  return 'https://repair-Pybackend.smartgonext.com';
};

const api = axios.create({
  baseURL: getBaseURL(),
  // Shared-hosting (Passenger/cPanel) workers can idle-sleep and take a while to
  // cold-start. The old 15s default caused 'timeout of 15000ms exceeded' errors on
  // the first request after wake-up. Use a generous default; individual calls can
  // still pass a smaller `timeout` per request when needed.
  timeout: 30000,
});

// Add interceptor to add token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // AuthContext has its own response interceptor that calls logout() cleanly.
    // We don't want to perform a hard window reload here.
    return Promise.reject(error);
  }
);

export default api;
